export default {
    error_title: '¡Error!',
    warning_title: '¡Advertencia!',
    wrong_input_title: '¡Campos inválidos!',
    action_not_done: '¡Solicitud fallida o en conflicto!',
    error_asaas_payment: {
        invalid_value: 'El valor mínimo para cargos mediante Tarjeta de Crédito es R$5.00.',
        invalid_billingType: 'El método de pago no está permitido para suscripciones.',
    },
    without_connection: {
        title: 'Problema de conexión al servidor',
        message: 'Asegúrate de estar conectado a Internet.',
    },
    unexpected: {
        title: '¡Algo salió mal!',
        message: 'Lo siento, algo salió mal. Vuelve a intentarlo.'
    },
    maintenance: {
        title: '¡En mantenimiento!',
        message: 'Lo sentimos, actualmente estamos en mantenimiento. Vuelve a intentarlo después de unos minutos.'
    },
    recaptcha: {
        alert_title: 'Problema con ReCaptcha',
        alert_body: 'Nuestro sitio está protegido por ReCaptcha de Google, pero no hay momento para verificar si el navegador está seguro. ' +
            'Por favor tente novamente, se o problema persistir entre em contato.',
        refresh: 'Error al obtener el token de recaptcha. Recarga la página.',
    },
    imap_connection: {
        title: '¡No se puede conectar al servidor IMAP!',
        message: 'No se puede conectar al servidor IMAP usando los datos ingresados en el formulario. ' +
            'Verifique los datos del formulario y vuelva a intentarlo.',
    },
    '400': 'Problema na requisição, tentativa nueva.',
    '401': 'Sesión terminada, inicie sesión de nuevo.',
    '403': "No tienes permiso para realizar esta acción",
    '404': 'Registro no encontrado',
    '419': 'Sección caducada, actualice la página.',
    '422': 'Corregir errores en campos de formulario.',
    '429': 'Muchas solicitudes en segundos. Espere unos segundos y vuelva a intentarlo.',
}
